module.exports = __webpack_public_path__ + "img/ezgif.com-gif-maker.b37b04b4.gif";